import Api from 'api';
import { StudentPaymentMethod } from '@axl/accel-framework/models';
import { CrudApi } from '@axl/accel-framework/api';

export default class PaymentMethodApi extends CrudApi<StudentPaymentMethod> {

    constructor(api: Api) {
        super(api, {
            endpoint: '/student/payment-method',
            parse: e => StudentPaymentMethod.fromJson(e)
        });
    }
}
